import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

// Configuration for superMarct project
// Using optional chaining to avoid "Cannot read properties of undefined" if import.meta.env is missing
const rawEnv = (import.meta as any).env || {};
// Spaties/enters of aanhalingstekens rond waarden in de deploy-instellingen maken
// de config ongeldig ("api-key-not-valid"); die halen we weg.
const clean = (v: any): string | undefined =>
    typeof v === 'string' ? (v.trim().replace(/^["']+|["']+$/g, '').trim() || undefined) : v;
const env = new Proxy(rawEnv, { get: (target, key) => clean(target[key as any]) });

// OBFUSCATION LOGIC:
// We plakken de key runtime weer aan elkaar.
// Vite heeft __FIREBASE_KEY_P1__ ("AIza") en __FIREBASE_KEY_P2__ (de rest) geïnjecteerd.
// Hierdoor staat de volledige string "AIzaSy..." nergens letterlijk in de broncodebundel.
// @ts-ignore
const apiKeyPart1 = typeof __FIREBASE_KEY_P1__ !== 'undefined' ? __FIREBASE_KEY_P1__ : "";
// @ts-ignore
const apiKeyPart2 = typeof __FIREBASE_KEY_P2__ !== 'undefined' ? __FIREBASE_KEY_P2__ : "";

// Fallback naar env var voor dev/test als define niet werkte (maar probeer brackets te gebruiken)
const finalApiKey = (apiKeyPart1 && apiKeyPart2) 
    ? (apiKeyPart1 + apiKeyPart2) 
    : env['VITE_FIREBASE_API_KEY'];

const projectId = env['VITE_FIREBASE_PROJECT_ID'];
// Auto-construct authDomain if missing but projectId is present
const authDomain = env['VITE_FIREBASE_AUTH_DOMAIN'] || (projectId ? `${projectId}.firebaseapp.com` : undefined);

const firebaseConfig = {
  apiKey: finalApiKey,
  authDomain: authDomain,
  projectId: projectId,
  storageBucket: env['VITE_FIREBASE_STORAGE_BUCKET'],
  messagingSenderId: env['VITE_FIREBASE_MESSAGING_SENDER_ID'],
  appId: env['VITE_FIREBASE_APP_ID'],
  measurementId: env['VITE_FIREBASE_MEASUREMENT_ID']
};

// Initialize Firebase
let app: any = null;
let db: any = null;
let auth: any = null;
let functions: any = null;

if (finalApiKey) {
    try {
        app = initializeApp(firebaseConfig);
        db = getFirestore(app);
        auth = getAuth(app);
        functions = getFunctions(app, "us-central1"); // Default regio voor functions
    } catch (e) {
        console.error("Firebase initialization failed:", e);
    }
} else {
    console.warn("Firebase API key missing. App will run in offline/demo mode.");
}

export { app, db, auth, functions };

// Helper to check status
export const isFirebaseReady = () => {
    return !!app && !!finalApiKey;
};
// Diagnose voor Instellingen → App-status (toont nooit de sleutel zelf)
export const firebaseDiagnostics = {
    keyStatus: !finalApiKey
        ? 'ontbreekt'
        : (finalApiKey.startsWith('AIza') && finalApiKey.length === 39)
            ? `formaat ok (AIza…${finalApiKey.slice(-4)})`
            : `afwijkend formaat (${finalApiKey.length} tekens)`,
    projectId: projectId || 'ontbreekt',
    authDomain: authDomain || 'ontbreekt',
};
